import React from 'react';

import { styled } from '@mui/material/styles';
import {
  Box,
  LinearProgress,
  Stack,
  Typography,
  linearProgressClasses,
  useMediaQuery,
} from '@mui/material';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 4,
  borderRadius: 8,

  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.neutral600.main,
  },

  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 8,
    backgroundColor: theme.palette.primaryBrandPurwadhika.main,
  },
}));

const UserProgress = ({ title, progress }) => {
  const isDesktop = useMediaQuery(({ breakpoints }) => breakpoints.up('md'));

  return (
    isDesktop && (
      <Box width="242px">
        <Stack spacing={1}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="metatag1"
              color="neutral300.main"
              textTransform="uppercase"
            >
              {title}
            </Typography>
            <Typography variant="metatagreguler" color="neutral400.main">
              {progress} of 100%
            </Typography>
          </Stack>

          <BorderLinearProgress variant="determinate" value={progress} />
        </Stack>
      </Box>
    )
  );
};

export default UserProgress;
